import { usePresenceStore } from "../../stores/presence";

function OnlineUsersDropdown() {
  const users = usePresenceStore((state) => state.users);
  const count = usePresenceStore((state) => state.count);

  if (count === 0) return null;

  return (
    <div className="navbar-item dropdown">
      <a
        href="#/"
        data-bs-toggle="dropdown"
        className="navbar-link dropdown-toggle icon"
      >
        <i className="fa fa-users"></i>
        <span className="badge">{count}</span>
      </a>
      <div className="dropdown-menu media-list dropdown-menu-end">
        <div className="dropdown-header">ONLINE ({count})</div>
        {users.map((user) => (
          <div
            key={user.id}
            className="dropdown-item d-flex align-items-center"
          >
            <i
              className="fa fa-circle text-success me-2"
              style={{ fontSize: "8px" }}
            ></i>
            <div>
              <div className="fw-bold">{user.name}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default OnlineUsersDropdown;
